/** @format */

import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Box from "../../atoms/box/Box";
import { ProjectTemplateProps } from "./ProjectTemplate.types";
import List from "../../molecules/list/List";
import { useIsMobile } from "../../../hooks/customDeviceDetect";
import IdeaCard from "../../molecules/cards/IdeaCard";
import Toolbar from "../../molecules/toolbar/Toolbar";

const ProjectTemplate: FC<ProjectTemplateProps> = ({
  data,
  ideaMap,
  handle,
  filteredIdeasData,
  user,
  setSearchOpen,
  searchOpen,
  searchTerm,
  setSearchTerm,
  checkedSortOption,
  setCheckedSortOption,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <div className="max-h-screen w-full overflow-y-auto px-5" id="ideaMapList">
      <Box margin={isMobile ? "54px 0px 16px 0px" : "14px 0px 16px 0px"}>
        <Toolbar
          setSearchOpen={setSearchOpen}
          searchOpen={searchOpen}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchPlaceholder={t("global:searchBarPlaceholder")}
          checkedSortOption={checkedSortOption}
          setCheckedSortOption={setCheckedSortOption}
          sortOptions={[
            { value: "newest", label: t("global:newest") },
            { value: "hottest", label: t("global:hottest") },
          ]}
        />
      </Box>
      <List
        lightCard={true}
        handle={handle}
        project={data}
        user={user}
        CardType={IdeaCard}
        ideaMap={ideaMap}
        data={filteredIdeasData}
        listEndText={
          filteredIdeasData?.length === 0 && data?.ideas?.length > 0
            ? t("global:noIdeasWithFilter")
            : filteredIdeasData?.length > 0
              ? t("global:noMorePosts")
              : data?.ideas?.length < 1
                ? t("util:nothingToShow", { val: t("global:posts") })
                : filteredIdeasData?.length < 1 && t("global:noMorePosts")
        }
      />
    </div>
  );
};

export default ProjectTemplate;
